<template>
  <div class="beneficios">
    <div class="container custom-container">
      <div class="row">
        <div class="col-24 col-lg-6">
          <div class="beneficios--item">
            <span class="item--icon icon icon-clock"></span>
            <p class="item--text">
              Segunda a sexta: <span class="highlight">08h às 18h</span> <br />
              Sabado: <span class="highlight">08h às 12h</span>
            </p>
            <span class="item--obs">*consulte horário para sua cidade</span>
          </div>
        </div>
        <div class="col-24 col-lg-6">
          <div class="beneficios--item">
            <span class="item--icon icon icon-place"></span>
            <p class="item--text">
              <span class="highlight">Peça de onde estiver</span><br />
              e vamos até você
            </p>
          </div>
        </div>
        <div class="col-24 col-lg-6">
          <div class="beneficios--item">
            <span class="item--icon icon icon-battery"></span>
            <p class="item--text">
              <span class="highlight">Serviço oficial</span> <br />
              baterias Heliar
            </p>
          </div>
        </div>
        <div class="col-24 col-lg-6">
          <div class="beneficios--item">
            <span class="item--icon icon icon-thumbs-up"></span>
            <p class="item--text">
              Entrega <span class="highlight">segura</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "beneficios",
};
</script>

<style lang="scss">
.beneficios {
  color: $cinza-escuro;
  padding-bottom: 84px;
  padding-top: 84px;
  &--item {
    text-align: center;
    .item {
      &--icon {
        color: $verde-heliar;
        font-size: 88px;
        line-height: 0;
        display: inline-block;
        margin-bottom: 17px;
      }
      &--text {
        font-size: 19px;
        line-height: normal;
        margin-bottom: 18px;
        .highlight {
          font-weight: 700;
        }
      }
      &--obs {
        font-size: 14px;
        line-height: normal;
        display: inline-block;
      }
    }
  }
}
@media (max-width: 1600px) {
  .beneficios {
    &--item {
      .item {
        &--text {
          font-size: 16px;
        }
        &--obs {
          font-size: 12px;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .beneficios {
    padding-top: 106px;
    padding-bottom: 106px;
    .row {
      .col-24 {
        &:last-child {
          .beneficios {
            &--item {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    &--item {
      margin-bottom: 56px;
      .item {
        &--icon {
          font-size: 120px;
          margin-bottom: 12px;
        }
        &--text {
          font-size: 36px;
          margin-bottom: 14px;
        }
        &--obs {
          font-size: 28px;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .beneficios {
    &--item {
      .item {
        &--icon {
          font-size: 110px;
        }
        &--text {
          font-size: 26px;
        }
        &--obs {
          font-size: 18px;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .beneficios {
    &--item {
      .item {
        &--icon {
          font-size: 100px;
        }
        &--text {
          font-size: 20px;
        }
        &--obs {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
